export const AA_MONOMER_LIBRARY_URL = '/aa-monomers/listing';
